var formatBytes = function(bytes) {
    if (bytes === 0) {
        return "0 Bytes";
    }

    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    Number.prototype.round = function(places) {
        return +(Math.round(this + "e+" + places)  + "e-" + places);
    };
    return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
}

var tooltipDateFormat = function(timestamp, timePeriod, lang) {
    var s;
    if (timePeriod === 'last-24-hours') {
        s = new Date(timestamp).toLocaleString(lang, {
            weekday: "long",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    }
    else {
        s = new Date(timestamp).toLocaleString(lang, {
            weekday: "long",
            month: "short",
            day: "numeric"
        });
    }
    return s;
}

var calcArrayPercentages = function(arr) {
    if (typeof arr === 'undefined' || arr.length === 0) {
        return arr;
    }

    var sum = arr.reduce(function(prev, curr) {
        return prev + curr;
    });

    var roundArr = [];
    var sumRound = 0;
    for (var i = 0; i < arr.length; i++) {
        sumRound += Math.round(100*arr[i]/sum);
        roundArr.push(sumRound);
    }

    var resultArr = [];
    for (var i = 0; i < arr.length; i++) {
        var prev = i === 0 ? 0 : roundArr[i- 1];
        resultArr.push(roundArr[i] - prev);
    }
    return resultArr;
}

var calcDictionaryPercentages = function(dict, keyField, valueField) {
    if (typeof dict === 'undefined' || dict.length === 0) {
        return dict;
    }

    var arr = [];
    for (var i = 0; i < dict.length; i++) {
        arr.push(dict[i]['y']);
    }

    var arrPercentages = calcArrayPercentages(arr);

    var result = [];
    for (var i = 0; i < dict.length; i++) {
        var obj = {};
        obj[keyField] = dict[i][keyField];
        obj[valueField] = arrPercentages[i];
        result.push(obj);
    }
    return result;
}

module.exports = {
    formatBytes: formatBytes,
    tooltipDateFormat: tooltipDateFormat,
    calcArrayPercentages: calcArrayPercentages,
    calcDictionaryPercentages: calcDictionaryPercentages,
}


// WEBPACK FOOTER //
// ./src/lib/analytics.js